import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { SharedModule } from '../../../shared.module';
import { ColumnComponent } from '../column.component';
import { SectionColumnProductInfoType } from 'src/app/models/enum/shared/section-column-product-info-type';
import { BadgeAsset } from 'src/app/models/image/dto/badge-asset';
import type { SectionColumnConfigDataValue } from '../../../../../models/enum/shared/section-column-config-data-value';

@Component({
  selector: 'app-column-energy-score',
  imports: [AsyncPipe, SharedModule],
  templateUrl: './column-energy-score.component.html',
  styleUrl: './column-energy-score.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ColumnEnergyScoreComponent extends ColumnComponent {
  constructor() {
    super();
  }
  @Input() displayFormat: SectionColumnConfigDataValue;

  getNonListColumnItem(): BadgeAsset | string | undefined {
    if (this.colVm.columnConfigDataValueIsBadgeMode()) {
      return this.rowVm.getBadgeAssetForColumnType(SectionColumnProductInfoType.EnergyScore)?.image;
    }
    return this.rowVm.getEnergyScore()?.toString() ?? '';
  }
}
